import React from 'react';
import logo from '../assets/logo.png';
import './fixbar.css';

class FixBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            downloadInProgress: false
        }
    }

    sendEvent = () => {
        if(window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.0') === 0) {
            return;
        }

        if(!sessionStorage.getItem('visit')) {
            sessionStorage.setItem('visit', true);

            fetch('https://api.ipify.org?format=json')
                .then((ipResp) => ipResp.json().then((ipJson) => {
                    fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/log_event', {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({type: 'download', name: 'artmedica.binary.ro', from: ipJson}),
                    }).then((response) => response.json().then((responseData) => {
                        sessionStorage.setItem('success', responseData.EventId);
                    }));
                })
            );
        }
    }

    downloadPublicFile = async () => {
        this.setState({
            downloadInProgress: true
        });

        this.sendEvent();

        // await new Promise(r => setTimeout(r, 2000));
        fetch('/download/1403.apk')
            .then((response) => response.blob())
        .then((blob) => {
            this.setState({
                downloadInProgress: false
            });

            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement("a");
            link.href = url;
            link.download = 'art-medica.apk'
            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            console.error("Error fetching the file:", error);
        });
    }

    openPlayStorePage() {
        const url = 'https://play.google.com/apps/internaltest/4701120434361138248';   
        window.open(url, '_blank');
    }

    render() {
        return(
            <div id='fix-bar-outer'>
                <div className='bara'>
                    <div id='fix-bar-logo-around'><img id='fix-bar-logo' alt='logo' src={logo} /></div>
                    <div className='btn-header in-evidenta no-select'  onClick={() => this.props.participate()}>Doresc acces</div>
                    <div className='btn-header no-select' onClick={this.openPlayStorePage}>Descarca Aplicatie</div>
                </div>
            </div>
        )
    }
}

export default FixBar;
